import _ from 'lodash';
import { E_BusinessMode } from '@/apis/service/PackageApi.types';
export function normalizePackageBusinessModes(pkgOrBusinessMode) {
    const rawBusinessMode = _.isString(pkgOrBusinessMode) || _.isArray(pkgOrBusinessMode)
        ? pkgOrBusinessMode
        : pkgOrBusinessMode?.business_mode ?? pkgOrBusinessMode?.businessMode;
    const modes = _.isArray(rawBusinessMode)
        ? rawBusinessMode
        : _.isString(rawBusinessMode) && _.trim(rawBusinessMode)
            ? _.split(rawBusinessMode, ',')
            : [E_BusinessMode.SEATS];
    const normalizedModes = _.map(modes, mode => _.toLower(_.trim(mode)))
        .filter(Boolean);
    return _.uniq(normalizedModes);
}
export function canUseInCreditsPrivilege(pkg) {
    return _.includes(normalizePackageBusinessModes(pkg), E_BusinessMode.CREDITS);
}
export function canUseInSeatsPrivilege(pkg) {
    return _.includes(normalizePackageBusinessModes(pkg), E_BusinessMode.SEATS);
}
